<template>
  <div class="check-box">
    <svg v-if="active" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 0C2.69169 0 0 2.69146 0 6C0 9.30854 2.69169 12 6 12C9.30831 12 12 9.30854 12 6C12 2.69146 9.30831 0 6 0ZM9.345 3.999L5.65269 8.15285C5.56177 8.25508 5.43508 8.30769 5.30746 8.30769C5.20615 8.30769 5.10438 8.27446 5.01923 8.20662L2.71154 6.36046C2.51262 6.20146 2.48031 5.91092 2.63954 5.71177C2.79854 5.51262 3.08931 5.48031 3.28823 5.63954L5.25369 7.21177L8.655 3.38538C8.82392 3.19477 9.11608 3.17769 9.30646 3.34708C9.49708 3.51669 9.51438 3.80838 9.345 3.999Z" fill="#199be2"/>
    </svg>
    <svg v-else width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 0C2.69169 0 0 2.69146 0 6C0 9.30854 2.69169 12 6 12C9.30831 12 12 9.30854 12 6C12 2.69146 9.30831 0 6 0ZM9.345 3.999L5.65269 8.15285C5.56177 8.25508 5.43508 8.30769 5.30746 8.30769C5.20615 8.30769 5.10438 8.27446 5.01923 8.20662L2.71154 6.36046C2.51262 6.20146 2.48031 5.91092 2.63954 5.71177C2.79854 5.51262 3.08931 5.48031 3.28823 5.63954L5.25369 7.21177L8.655 3.38538C8.82392 3.19477 9.11608 3.17769 9.30646 3.34708C9.49708 3.51669 9.51438 3.80838 9.345 3.999Z" fill="#C4C4C4"/>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    active: {
      
    }
  }
}
</script>

<style lang="scss" scoped>

.check-box {
  border-radius: 100%;
  // box-shadow: 0 3px 10px rgba($color: #000000, $alpha: 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>